import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import WindowDimensionsProvider, {
  WindowDimensionsConsumer,
} from 'shared-assets/components/WindowDimensionsProvider';
import rollbar from 'shared-assets/src/errors/errors';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';

import AuthenticatedUi from './components/AuthenticatedUi';
import BrowserSupport from './components/BrowserSupport';
import EndSession from './components/EndSession';
import LayoutCentered from './components/LayoutCentered';
import LoadingUi from './components/LoadingUi';
import PublicBetaUi from './components/PublicBetaUi';
import PublicUi from './components/PublicUi';

import StaticLinkView from './scenes/StaticLinkView';

import FriendlyErrorPage from './components/FriendlyErrorPage';
import { wherebyMobileSupport } from './util/browser';

const VERSIONS = {
  v1: 'v1',
  v2: 'v2',
};

function withErrorBoundary(WrappedComponent) {
  // we will turn off react logging since we log directly
  // eslint-disable-next-line no-extend-native
  Error.prototype.suppressReactErrorLogging = true;
  return class TempDashboardApptErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: false };
    }
    componentDidCatch(error) {
      // react catches it's own errors and logs directly to console
      rollbar.error(error);
      this.setState({
        error: true,
      });
    }

    render() {
      return this.state.error ? (
        <FriendlyErrorPage />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };
}

const Routes = () => {
  let [version, setVersion] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      setVersion(VERSIONS.v2);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return (
    <Switch>
      <Route
        exact
        path="/"
        component={() => {
          throw new Error(
            'You must have an uniqueIdForUrl to start a sessions',
          );
        }}
      />
      {/** show browser suppport page when broswer isnt supported by whereby */}
      <If condition={!wherebyMobileSupport()}>
        <Route path="*" component={BrowserSupport} />
      </If>
      <If condition={version === null}>
        <Route
          path="*"
          render={() => {
            return (
              <LayoutCentered>
                <TelehealthLogo />
                <LoadingUi isLoading />
              </LayoutCentered>
            );
          }}
        />
      </If>
      <Route path="/static/:providerSlug" component={StaticLinkView} />
      <If
        condition={window?.location?.hostname?.includes('telehealth.kareo.com')}
      >
        <Route path="/:providerSlug" component={StaticLinkView} />
      </If>
      <Route path="/endSession/:uniqueIdForUrl" component={EndSession} />
      <If condition={version === VERSIONS.v1}>
        {/** version 1 both UI's revert back to no authentication
         * this will be removed once the beta feature toggle is removed
         */}
        <Route path="/session/:uniqueIdForUrl" component={PublicBetaUi} />
        <Route path="/:uniqueIdForUrl" component={PublicBetaUi} />
      </If>
      <If condition={version === VERSIONS.v2}>
        {/** version 2 providers and patients are both validated through new endpoints */}
        <Route path="/session/:uniqueIdForUrl" component={AuthenticatedUi} />
        <Route path="/:uniqueIdForUrl" component={PublicUi} />
      </If>
      <Route
        component={() => {
          throw new Error(
            'You must have an uniqueIdForUrl to start a sessions',
          );
        }}
      />
    </Switch>
  );
};

const TelehalthUi = withErrorBoundary(() => {
  let Router = HashRouter;
  if (window?.location?.hostname?.includes('telehealth.kareo.com')) {
    Router = BrowserRouter;
  }

  return (
    <WindowDimensionsProvider>
      <Router>
        <Routes />
      </Router>
      {/**  WindowDimensionsConsumer updates the global css variables used in cssVariableDefaultStyles */}
      <WindowDimensionsConsumer />
    </WindowDimensionsProvider>
  );
});

ReactDOM.render(<TelehalthUi />, document.getElementById('app-root'));
